<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,0C5.6,0,3.46,1.07,2,2.74C2,2.74,2,1,2,1C2,0.45,1.55,0,1,0C0.45,0,0,0.45,0,1C0,1,0,5,0,5C0,5.55,0.45,6,1,6C1,6,5,6,5,6C5.55,6,6,5.55,6,5C6,4.45,5.55,4,5,4C5,4,3.54,4,3.54,4C4.64,2.78,6.22,2,8,2C11.31,2,14,4.69,14,8C14,10.61,12.33,12.81,10,13.63C9.37,13.85,8.71,14,8,14C4.69,14,2,11.31,2,8C2,7.45,1.55,7,1,7C0.45,7,0,7.45,0,8C0,12.42,3.58,16,8,16C8.34,16,8.67,15.97,9,15.93C9.02,15.93,9.04,15.92,9.06,15.92C12.98,15.4,16,12.06,16,8C16,3.58,12.42,0,8,0C8,0,8,0,8,0ZM11,5C10.72,5,10.47,5.11,10.29,5.29C10.29,5.29,7,8.58,7,8.58C7,8.58,5.71,7.29,5.71,7.29C5.53,7.11,5.28,7,5,7C4.45,7,4,7.45,4,8C4,8.28,4.11,8.53,4.29,8.71C4.29,8.71,6.29,10.71,6.29,10.71C6.47,10.89,6.72,11,7,11C7.28,11,7.53,10.89,7.71,10.71C7.71,10.71,11.71,6.71,11.71,6.71C11.89,6.53,12,6.28,12,6C12,5.45,11.55,5,11,5C11,5,11,5,11,5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Updated',
} as DefineComponent
</script>
